import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PagingModule } from '../../components/common/search/paging.module';
import { TooltipModule } from 'ngx-tooltip';
import { RegistrationDetailsComponent } from './registration.details.component';
import { RegistrationFurtherInfoComponent } from './registration.further.info.component';
import { ThankYouComponent } from './thank.you.component';
import { ValidateEmailComponent } from './validate.email.component';
import { ValidationCompleteComponent } from './validation.complete.component';
import { ValidationModule } from '../../components/common/validation/validation.module';
import { TermsAndConditionsModalModule } from '../../components/common/terms.and.conditions.modal/t.and.c.modal.module';
import { AcceptTeamInvitationComponent } from './accept.team.invite.component';
import { TeamMemberThankYouComponent } from './team.member.thank.you.component';
import { CategoryTreeViewModule } from '../../components/common/category.tree.view/category.tree.view.module';
import { SupplierRegistrationComponent } from './supplier.registration.component';
import { RouterModule } from '@angular/router';
import { UnsubscribeComponent } from './unsubscribe.component';
import { BlockUIModule } from 'ng-block-ui';
import {B2BAngularMaterialModule} from '../../components/common/angular.material/b2b.angular.material.module';
import { ImgSrcPrefixPipeModule } from '../../components/pipes/imgsrcprefix.pipe/img.src.pipe.module';
import {SafeHtmlPipeModule} from '../../components/pipes/safehtml.pipe/safe.html.pipe.module';

@NgModule({
    declarations: [
        RegistrationDetailsComponent,
        RegistrationFurtherInfoComponent,
        ThankYouComponent,
        ValidateEmailComponent,
        ValidationCompleteComponent,
        AcceptTeamInvitationComponent,
        TeamMemberThankYouComponent,
        SupplierRegistrationComponent,
        UnsubscribeComponent],
    imports: [
        RouterModule,
        BrowserModule,
        FormsModule,
        PagingModule,
        TooltipModule,
        ValidationModule,
        TermsAndConditionsModalModule,
        CategoryTreeViewModule,
        BlockUIModule,
        B2BAngularMaterialModule,
        ImgSrcPrefixPipeModule,
        SafeHtmlPipeModule]
})

export class RegistrationModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/registration.module.ts